import {
  LOGIN,
  SESSION,
  LOGOUT,
  LIST_ACCOUNT,
  LIST_ACCOUNTCOUNTRY,
  ALL_ACCOUNT,
  REGISTER_ACCOUNT,
  SHOW_ACCOUNT,
  UPDATE_ACCOUNT,
  REMOVE_ACCOUNT,
  LIST_PROJECT,
  ALL_PROJECT,
  REGISTER_PROJECT,
  SHOW_PROJECT,
  UPDATE_PROJECT,
  REMOVE_PROJECT,
  LIST_USER,
  ALL_USER,
  REGISTER_USER,
  SHOW_USER,
  UPDATE_USER,
  REMOVE_USER,
  LIST_TEAM,
  ALL_TEAM,
  REGISTER_TEAM,
  SHOW_TEAM,
  UPDATE_TEAM,
  REMOVE_TEAM,
  LIST_CAMPAIGN,
  ALL_CAMPAIGN,
  REGISTER_CAMPAIGN,
  SHOW_CAMPAIGN,
  UPDATE_CAMPAIGN,
  REMOVE_CAMPAIGN,
  LIST_SOCIALREASON,
  ALL_SOCIALREASON,
  LIST_TASK,
  LIST_TASKSTATE,
  ALL_TASK,
  REGISTER_TASK,
  SHOW_TASK,
  UPDATE_TASK,
  ALL_TASKVERSION,
  SHOW_TASKVERSION,
  REGISTER_TASKVERSION,
  LIST_TASKVERSION,
  LIST_EMAIL,
  LIST_EMAILSTATE,
  LIST_EMAILCHECK,
  ALL_EMAIL,
  REGISTER_EMAIL,
  SHOW_EMAIL,
  UPDATE_EMAIL,
  ALL_EMAILVERSION,
  REGISTER_EMAILVERSION,
  LIST_PROFILE,
  ALL_PROFILE,
  REGISTER_PROFILE,
  SHOW_PROFILE,
  UPDATE_PROFILE,
  REMOVE_PROFILE,
  LIST_HOUR,
  ALL_HOUR,
  REGISTER_HOUR,
  SHOW_HOUR,
  UPDATE_HOUR,
  LIST_CALENDAR,
  ALL_CALENDAR,
  REGISTER_CALENDAR,
  SHOW_CALENDAR,
  UPDATE_CALENDAR,
  REMOVE_CALENDAR,
  LIST_NOTIFICATION,
  UPDATE_NOTIFICATION,
  ALL_ACCOUNTUSER,
  REGISTER_ACCOUNTUSER,
  REMOVE_ACCOUNTUSER,
  ALL_NOTIFICATION,
  REMOVE_POINT,
} from './mutation-types'

import axios from '../../services/axios'
import axiosmongotasks from '../../services/axios-mongo-tasks'
import axiosmongoemails from '../../services/axios-mongo-emails'
import axiosmongocalendars from '../../services/axios-mongo-calendars'

// CRUD
export async function getList({ commit }, entity) {
  let query = ''
  if (Array.isArray(entity)) {
    query = `?${entity['1']}`
    entity = entity['0']
  }
  //console.log(entity)
  return new Promise((resolve, reject) => {
    axios
      .get(`${entity}/list${query}`)
      .then((response) => {
        let mutation = `${entity}/LIST_${entity.toUpperCase()}`
        commit(mutation, response.data.list)
        //console.log(response)
        resolve(response.data)
      })
      .catch((error) => {
        console.log(error)
        if (error.response && error.response.data) {
          window.$toast.info(error.response.data.message)
        } else {
          //window.$toast.info('Error al listar datos, intente de nuevo!')
        }
        reject(error)
      })
  })
}

export async function getListTasksMongo({ commit }, entity) {
  let query = ''
  if (Array.isArray(entity)) {
    query = `?${entity['1']}`
    entity = entity['0']
  }
  return new Promise((resolve, reject) => {
    axiosmongotasks
      .get(`${entity}/list${query}`)
      .then((response) => {
        let mutation = `${entity}/LIST_${entity.toUpperCase()}`
        commit(mutation, response.data.list)
        //console.log(response)
        resolve(response.data)
      })
      .catch((error) => {
        console.log(error)
        if (error.response && error.response.data) {
          window.$toast.info(error.response.data.message)
        } else {
          //window.$toast.info('Error al listar datos, intente de nuevo!')
        }
        reject(error)
      })
  })
}

export async function getListEmailsMongo({ commit }, entity) {
  let query = ''
  if (Array.isArray(entity)) {
    query = `?${entity['1']}`
    entity = entity['0']
  }
  return new Promise((resolve, reject) => {
    axiosmongoemails
      .get(`${entity}/list${query}`)
      .then((response) => {
        let mutation = `${entity}/LIST_${entity.toUpperCase()}`
        commit(mutation, response.data.list)
        //console.log(response)
        resolve(response.data)
      })
      .catch((error) => {
        console.log(error)
        if (error.response && error.response.data) {
          window.$toast.info(error.response.data.message)
        } else {
          //window.$toast.info('Error al listar datos, intente de nuevo!')
        }
        reject(error)
      })
  })
}

export async function getListCalendarsMongo({ commit }, entity) {
  let query = ''
  if (Array.isArray(entity)) {
    query = `?${entity['1']}`
    entity = entity['0']
  }
  return new Promise((resolve, reject) => {
    axiosmongocalendars
      .get(`${entity}${query}`)
      .then((response) => {
        //console.log(response)
        resolve(response.data)
      })
      .catch((error) => {
        console.log(error)
        if (error.response && error.response.data) {
          window.$toast.info(error.response.data.message)
        } else {
          //window.$toast.info('Error al listar datos, intente de nuevo!')
        }
        reject(error)
      })
  })
}

export async function getAll({ commit }, entity) {
  return new Promise((resolve, reject) => {
    axios
      .get(entity)
      .then((response) => {
        var mutation = entity + '/ALL_' + entity.toUpperCase()
        commit(mutation, response.data.list)
        //console.log(response.data)
        resolve(response.data)
      })
      .catch((error) => {
        console.log(error)
        if (error.response && error.response.data) {
          window.$toast.info(error.response.data.message)
        } else {
          //window.$toast.info('Error al listar datos, intente de nuevo!')
        }
        reject(error)
      })
  })
}

export async function store({ commit }, form) {
  return new Promise((resolve, reject) => {
    let query = ''
    if (Array.isArray(form)) {
      query = `?${form['1']}`
      form = form['0']
    }
    let entity = form.entity
    let header = {}
    if (form instanceof FormData) {
      entity = form.get('entity')
      console.log(entity)
      header = { 'Content-Type': 'multipart/form-data, application/json' }
    }
    // axios.post(entity, form, {headers : header})
    axios
      .post(`${entity}${query}`, form)
      .then((response) => {
        let mutation = `${entity}/REGISTER_${entity.toUpperCase()}`
        commit(mutation, response.data)
        if (response.data.list) {
          let mutationList = `${entity}/ALL_${entity.toUpperCase()}`
          commit(mutationList, response.data.list)
        }
        window.$toast.success('Datos creados correctamente')
        resolve(response.data)
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          window.$toast.info(error.response.data.message)
        } else {
          window.$toast.info('Error modificando los datos, intente de nuevo!')
        }
        reject(error)
      })
  })
}

export async function show({ commit }, form) {
  return new Promise((resolve, reject) => {
    let entity = form.entity
    axios
      .get(`${entity}/${form.id}`)
      .then((response) => {
        var mutation = entity + '/SHOW_' + entity.toUpperCase()
        commit(mutation, response.data.model)
        //console.log(response.data)
        resolve(response.data.model)
      })
      .catch((error) => {
        window.$toast.info('Error consultando los datos, intente de nuevo!')
        reject(error)
      })
  })
}

export async function update({ commit }, form) {
  return new Promise((resolve, reject) => {
    let query = ''

    if (Array.isArray(form)) {
      query = `?${form['1']}`
      form = form['0']
    }
    let entity = form.entity
    let id = form.id

    axios
      .put(`${entity}/${id}${query}`, form)
      .then((response) => {
        let mutation = `${entity}/UPDATE_${entity.toUpperCase()}`
        commit(mutation, response.data)
        if (response.data.list) {
          let mutationList = `${entity}/ALL_${entity.toUpperCase()}`
          commit(mutationList, response.data.list)
        }
        window.$toast.success('Datos modificados correctamente')
        //console.log(response.data)
        resolve(response.data)
      })
      .catch((error) => {
        console.log(error)
        if (error.response && error.response.data) {
          window.$toast.info(error.response.data.message)
        } else {
          window.$toast.info('Error modificando los datos, intente de nuevo!')
        }
        reject(error)
      })
  })
}

export async function remove({ commit }, form) {
  return new Promise((resolve, reject) => {
    var entity = form.entity
    axios
      .delete(entity + '/' + form.id)
      .then((response) => {
        var mutation = entity + '/REMOVE_' + entity.toUpperCase()
        commit(mutation, response.data.model)
        window.$toast.error('Se ha eliminado correctamente')
        //console.log(response.data)
        resolve(response.data.model)
      })
      .catch((error) => {
        window.$toast.info('Error eliminando registro, intente de nuevo!')
        reject(error)
      })
  })
}

// SESSION

export async function login({ commit }, user) {
  return new Promise((resolve, reject) => {
    axios
      .post('/auth/login', user)
      .then((response) => {
        commit(LOGIN, response.data.auth)
        localStorage.token = response.data.access_token
        axios.defaults.headers.Authorization =
          'Bearer ' + response.data.access_token
        resolve(response.data.auth)
      })
      .catch((error) => {
        window.$toast.info('Error al iniciar sesión, intente de nuevo!')
        reject(error)
      })
  })
}

export async function logout({ commit }, user) {
  return new Promise((resolve, reject) => {
    delete localStorage.token
    delete localStorage.session_account
    delete localStorage.session_team
    commit(LOGOUT, user)
    resolve(user)
  })
}

export async function session({ commit }) {
  return new Promise((resolve, reject) => {
    axios
      .get('/auth/user')
      .then((response) => {
        //console.log(response.data);
        commit(SESSION, response.data.auth)
        resolve(response.data.auth)
      })
      .catch((error) => {
        delete localStorage.token
        delete localStorage.session_account
        delete localStorage.session_team
        if (error.response.data) {
          window.$toast.info(error.response.data.message)
        }
        console.log('error session')
        reject(error)
      })
  })
}

// CRUD
export async function get({ commit }, url) {
  return new Promise((resolve, reject) => {
    axios
      .get(url)
      .then((response) => {
        //console.log(response)
        if (response.data.message) {
          window.$toast.success(response.data.message)
        }
        resolve(response.data)
      })
      .catch((error) => {
        console.log(error)
        if (error.response && error.response.data) {
          window.$toast.info(error.response.data.message)
        } else {
          //window.$toast.info('Error al listar datos, intente de nuevo!')
        }
        reject(error)
      })
  })
}

export async function post({ commit }, form) {
  return new Promise((resolve, reject) => {
    if (Array.isArray(form)) {
      query = `?${form['1']}`
      form = form['0']
    }
    let entity = form.entity
    axios
      .post(entity, form)
      .then((response) => {
        //console.log(response)
        if (response.data.message) {
          window.$toast.success(response.data.message)
        }
        resolve(response.data)
      })
      .catch((error) => {
        console.log(error)
        if (error.response && error.response.data) {
          window.$toast.info(error.response.data.message)
        } else {
          //window.$toast.info('Error al listar datos, intente de nuevo!')
        }
        reject(error)
      })
  })
}

export async function put({ commit }, data) {
  return new Promise((resolve, reject) => {
    if (Array.isArray(data)) {
      query = `?${data['1']}`
      data = data['0']
    }
    let entity = data.entity
    axios
      .put(entity + '/' + data['id'], data)
      .then((response) => {
        //console.log(response)
        if (response.data.message) {
          window.$toast.success(response.data.message)
        }
        resolve(response.data)
      })
      .catch((error) => {
        console.log(error)
        if (error.response && error.response.data) {
          window.$toast.info(error.response.data.message)
        } else {
          //window.$toast.info('Error al listar datos, intente de nuevo!')
        }
        reject(error)
      })
  })
}

export async function deleteItem({ commit }, data) {
  return new Promise((resolve, reject) => {
    axios
      .delete(data['entity'] + '/' + data['id'])
      .then((response) => {
        //console.log(response)
        if (response.data.message) {
          window.$toast.success(response.data.message)
        }
        resolve(response.data)
      })
      .catch((error) => {
        console.log(error)
        if (error.response && error.response.data) {
          window.$toast.info(error.response.data.message)
        } else {
          //window.$toast.info('Error al listar datos, intente de nuevo!')
        }
        reject(error)
      })
  })
}



// WEBPACK FOOTER //
// ./src/vuex/entity/actions.js